import { Decorative } from "@faire/design-tokens";
import {
  SignUpElement,
  SignUpType,
  usePopSignUp,
} from "@faire/retailer-visitor-shared/lib/popSignUp";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import styled from "styled-components";

export const ConsumerModeBanner = () => {
  const { isMobile } = useViewport();
  const { popSignUp } = usePopSignUp();
  return (
    <BannerWrapper justify="center">
      <Typography align="center">
        {isMobile ? (
          "Shopper Mode: Browse here, buy on partner sites."
        ) : (
          <>
            {"Shopper Mode: Browse here, buy on partner sites. Or "}
            <Button
              variant="tertiary"
              onClick={() =>
                popSignUp(SignUpType.GENERIC, () => {}, {
                  element: SignUpElement.TOP_BANNER,
                  sourceId: "consumer-mode-banner",
                })
              }
            >
              sign up
            </Button>
            {" for buying access if you have a retailer license."}
          </>
        )}
      </Typography>
    </BannerWrapper>
  );
};

const BannerWrapper = styled(Column)`
  background-color: ${Decorative.tint.blue};
  height: 40px;
`;
